<template>
    <div class='tabs-container' :style='[container_styles]' @click='tabContainerClick' :class="{'tab-group-empty' :container.blocks.length == 0 && container.styles.flex_direction.value == 'column'}" >
        <div v-for='tab in container.tabs' :key='tab.id'>
            <div class='tab-item' :style='[tab_styles]' @click.stop='selectTab(tab)' :class="{'active-tab' : active_tab == tab.id}">{{tab.name}}</div>
        </div>
    </div>
</template>

<script>
export default {
    props: ['container'],
    emits: ['tabContainerClickListener', 'tabSelectedListener'],
    data(){
        return{
            container_styles: {},
            tab_styles: {},
            active_tab: ''
        }
    },
    methods:{
        setStyles(){
            let container_styles = {};
            let tab_styles = {};

            if(this.container.tab_container_styles != null){
                Object.keys(this.container.tab_container_styles).forEach(key => {
                    const value = this.container.tab_container_styles[key];
                    container_styles[value.css_property] = value.value;
                });
            }
                this.container_styles = container_styles;

            if(this.container.tab_styles != null){
                Object.keys(this.container.tab_styles).forEach(key => {
                    const value = this.container.tab_styles[key];
                    tab_styles[value.css_property] = value.value;
                });
            }

            this.tab_styles = tab_styles;

        },
        selectTab(tab){
            // this.container.active_tab = tab.id;
            this.active_tab = tab.id;
            this.$emit('tabSelectedListener', this.container.id, tab.id);
        },
        tabContainerClick(){
            this.$emit('tabContainerClickListener', this.container.id);
        }
    },
    mounted(){
        this.setStyles();
        if(typeof this.container.tabs !== 'undefined'){
            if(this.container.tabs.length != 0){
                this.selectTab(this.container.tabs[0]);
                // this.container.active_tab = this.container.tabs[0].id;
            }
        }
    },
    watch:{
        'container': {
            handler(){  
                this.setStyles();
            },
            deep: true
        }
    },
}
</script>

<style lang="scss" scoped>
.tabs-container{
    display: flex;
    width: 100%;
}

.active-tab{
    text-decoration: underline;
}

.tab-item{
    cursor: pointer;
}
</style>